module.exports = __webpack_public_path__ + "media/images/icons/SVG/012-df887116de595ff26d4c1733d95c1ef7.svg";